export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-24.dde6af57.jpg";